import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { ForumTag } from './types';

import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';

export const useFavoriteForumTag = (tag: ForumTag) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (favorite: boolean) => {
      return fetchJson(`/forum/tags/${tag}/${favorite ? 'favorite' : 'unfavorite'}`, {
        method: 'POST',
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QueryKeys.user });
    },
  });
};
